//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: ${({ direction = "column" }) => direction};
    align-items: ${({ direction = "column" }) => direction === "column" ? "flex-start" : "center"};
    gap: 5px;
    & label {
        margin: 0;
        margin-bottom: ${({ direction = "column" }) => direction === "column" ? "5px" : 0};
        font-weight: bold;
        font-size: 14px;
    }
`;
export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
`;